<template>
    <div
        :class="['notification', `notification-type-${notification?.type}`]"
    >
        <Position y="center">
            <div class="notification-icon-wrapper">
                <i
                    v-if="icon"
                    :class="['notification-icon', icon]"
                />
            </div>
        </Position>

        <Position y="center">
            <Words
                text
                dense
                class="notification-message"
            >
                {{ message }}
            </Words>
        </Position>

        <Position y="center">
            <div
                class="notification-close"
                @click="closeNotification()"
            >
                <i class="mi-close" />
            </div>
        </Position>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import components from 'widget-components'
import Words from 'widget-components/components/Words/Words.vue'
import useNotifications from '@/composables/notifications'
import type { NotificationDetails } from '@/types'

const { Position } = components

const { closeNotification } = useNotifications()

const props = defineProps<{
    notification: NotificationDetails
}>()

const message = computed(() => props.notification?.content)

const ICONS_MAP: Record<NotificationDetails['subtype'], string> = {
    wait: 'mi-clock',
    connection: 'mi-switch',
    success: 'mi-check',
    info: 'mi-circle-information',
}

const icon = computed(() => {
    return ICONS_MAP[props.notification.subtype] || ''
})

const notification = computed(() => props.notification)
</script>
